<div class="card-title" translate>dashboard.spot.order-status</div>
<div *ngIf="!isLoading else loading" class="order-status-container">
	<button type="button" class="order-status" 
		*ngIf="{ disabled: orderQuantities?.qtyInProduction === undefined || orderQuantities?.qtyInProduction === 0} as qtyInProductionRipple"
		[class.copo-clickable]="!qtyInProductionRipple.disabled"
		[matRippleDisabled]="qtyInProductionRipple.disabled"
		(click)="!qtyInProductionRipple.disabled && viewDetails('grossQtyInProduction')" mat-ripple>
		<mat-icon svgIcon="in_production"></mat-icon>
		<div class="order-status-item" translate>order-tracking.in.production</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ orderQuantities?.qtyInProduction || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
		<div class="order-status-item order-percentage-label">
			{{ orderQuantities?.inProductionPercentage || 0 | copoNumber:'percentage-rounded': '%' }}
		</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: orderQuantities?.qtyAvailableReadyToShip === undefined || orderQuantities?.qtyAvailableReadyToShip === 0 } as qtyAvailableReadyToShipRipple"
		[class.copo-clickable]="!qtyAvailableReadyToShipRipple.disabled"
		[matRippleDisabled]="qtyAvailableReadyToShipRipple.disabled"
		(click)="!qtyAvailableReadyToShipRipple.disabled && viewDetails('grossQtyAvailableReadyToShip')" mat-ripple>
		<mat-icon svgIcon="in_stock"></mat-icon>
		<div class="order-status-item" translate>order-tracking.in.stock</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ orderQuantities?.qtyAvailableReadyToShip || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
		<div class="order-status-item order-percentage-label">
			{{ orderQuantities?.availableReadyToShipPercentage || 0 | copoNumber:'percentage-rounded': '%' }}
		</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: orderQuantities?.qtyAvailableInTransit === undefined || orderQuantities?.qtyAvailableInTransit === 0} as qtyAvailableInTransitRipple"
		[class.copo-clickable]="!qtyAvailableInTransitRipple.disabled"
		[matRippleDisabled]="qtyAvailableInTransitRipple.disabled"
		(click)="!qtyAvailableInTransitRipple.disabled && viewDetails('grossQtyAvailableInTransit')" mat-ripple>
		<mat-icon svgIcon="in_transit"></mat-icon>
		<div class="order-status-item" translate>order-tracking.in.transit</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ orderQuantities?.qtyAvailableInTransit || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
		<div class="order-status-item order-percentage-label">
			{{ orderQuantities?.inTransitPercentage || 0 | copoNumber:'percentage-rounded': '%' }}
		</div>
	</button>
	<button type="button" class="order-status" 
		*ngIf="{ disabled: orderQuantities?.qtyDelivered === undefined || orderQuantities?.qtyDelivered === 0 } as qtyDeliveredRipple"
		[class.copo-clickable]="!qtyDeliveredRipple.disabled"
		[matRippleDisabled]="qtyDeliveredRipple.disabled"
		(click)="!qtyDeliveredRipple.disabled && viewDetails('grossQtyDelivered')" mat-ripple>
		<mat-icon svgIcon="delivered"></mat-icon>
		<div class="order-status-item" translate>order-tracking.delivered</div>
		<div class="order-status-item order-weight-label label-orange-color">{{ orderQuantities?.qtyDelivered || 0 | copoNumber: 'weight-aggregate':'t' }}</div>
		<div class="order-status-item order-percentage-label">
			{{ orderQuantities?.deliveredPercentage || 0 | copoNumber:'percentage-rounded': '%' }}
		</div>
	</button>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<div class="card-block-footer mobile-hide">
	<button type="button" mat-button color="primary" (click)="viewDetails()">
		<span translate>order-tracking.card.delivery-date.view-details</span>
		<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
	</button>
</div>
